import { StoreModule } from '@ngrx/store';
import { MembershipFeatureKey } from './membership-feature-key';
import { membershipReducer } from './membership.reducer';

export * from './membership-feature-key';
export * from './membership.actions';
export * from './membership.effects';
export * from './membership.reducer';
export * from './membership.selectors';

export const MembershipStoreModule = StoreModule.forFeature(
  MembershipFeatureKey,
  membershipReducer
);
